<script>
import baseMixin from '@/mixins/baseMixin'
import EmptyStateBlock from '../general/empty-state-block.vue'

export default {
  name: 'FilePreviewGalleryEmptyBlock',
  components: { EmptyStateBlock },
  mixins: [baseMixin],
}
</script>

<template>
  <EmptyStateBlock>
    <template v-slot:icon>
      <v-icon color="white" class="mb-5" size="62">
        mdi-file-document-alert-outline
      </v-icon>
    </template>
    <template v-slot:title>
      <h2 class="white--text mb-2 font-weight-medium">{{
        $t('files.previewGallery.noFilesTitle')
      }}</h2>
    </template>
    <template v-slot:description>
      <p class="text-subtitle-1 white--text">{{
        $t('files.previewGallery.noFilesDescription')
      }}</p>
    </template>
    <template v-slot:button>
      <section class="mt-4">
        <v-btn
          data-testid="file-preview-gallery-empty-block-close-btn"
          dark
          class="white--text"
          outlined
          text
          large
          @click="$emit('closed')"
        >
          <v-icon left> mdi-close </v-icon>
          {{ $t('general.closeBtn') }}
        </v-btn>
      </section>
    </template>
  </EmptyStateBlock>
</template>
